import React from "react";
import { JdsTag } from "../../components/jds/JdsTag";

export const columns = [
  {
    name: "ID",
    selector: (row) => row.id,
    width: "150px",
  },
  {
    name: "Nome",
    selector: (row) => row.name,
    width: "200px",
  },
  {
    name: "E-mail",
    selector: (row) => row.email,
    width: "300px",
  },
  {
    name: "Tipo de vínculo",
    selector: (row) => row.linkType,
    width: "150px",
  },
  {
    name: "Ativo",
    selector: (row) => (row.status === "active" ? "Sim" : "Não"),
    cell: (row) => (
      <JdsTag
        label={row.status === "active" ? "Sim" : "Não"}
        color={row.status === "active" ? "success" : "neutral"}
      />
    ),
    width: "150px",
  },
  {
    name: "Detalhes do usuário",
    cell: (row) => (
      <a className="users-link" href={`users/${row.id}`} target="_blank" rel="noopener noreferrer">
        Abrir detalhes
      </a>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    width: "200px",
  },
  {
    name: "Página do cliente",
    cell: (row) =>{
      const clientId = row?.client_id || row?.parent_client_id;
      return clientId ? (
        <a className="users-link" href={`clientes/${clientId}`} target="_blank" rel="noopener noreferrer">
          Abrir cliente
        </a>
      ) : (
        "Sem cliente"
      );
    },
    ignoreRowClick: true,
    allowOverflow: true,
    width: "200px",
  },
];
